import Vue from 'vue'
import Router from 'vue-router'
import goTo from 'vuetify/es5/services/goto'

import store from './store'

Vue.use(Router)

const other = [
  {
    path: '/',
    name: 'root',
    component: () => import('./views/Beranda.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('./views/About.vue'),
  },
]

let routers = [...other]

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0

    if (to.hash) {
      scrollTo = to.hash
    } else if (savedPosition) {
      scrollTo = savedPosition.y
    }

    return goTo(scrollTo)
  },
  routes: routers,
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    store.commit('main/pStart')
  }
  next()
})

router.afterEach(() => {
  store.commit('main/pEnd')
  window.scrollTo(0, 0)
})

export default router
